import { ROLES_APPLICATION } from '@/core/constants/roles'
import { checkUserHaveRoles } from '@/core/utils/roles'
import { createRouter, createWebHistory } from 'vue-router'
import Errorpagesinfo from '../shared/layouts/errorpagesinfo.vue'
import MainDashboard from '../shared/layouts/mainDashboard.vue'
import Messagesinformation from '../shared/layouts/messagesinformation.vue'
import { authStore } from '../stores/auth'

const routes = [
  {
    component: MainDashboard,
    children: [
      {
        path: '/sec/',
        name: 'proyectosSec',
        component: () => import('@/components/pages/sec/proyectosSec.vue'),
        meta: {
          requiresAuth: true,
          requireRole: [ROLES_APPLICATION.PROJECTS_SEC_SUPERADMIN, ROLES_APPLICATION.PROJECTS_SEC]
        }
      },
      {
        path: '/sec/:id',
        name: 'proyectosSecItem',
        component: () => import('@/components/pages/sec/detailsProyectosSec.vue'),
        props: true,
        meta: {
          requiresAuth: true,
          requireRole: [ROLES_APPLICATION.PROJECTS_SEC_SUPERADMIN, ROLES_APPLICATION.PROJECTS_SEC]
        }
      },
      {
        path: `${import.meta.env.BASE_URL}/interconexiones`,
        name: 'interconexiones',
        component: () => import('@/components/pages/interconexiones/Interconexiones.vue'),
        meta: {
          requiresAuth: true,
          requireRole: [
            ROLES_APPLICATION.PROJECTS_SEC_SUPERADMIN,
            ROLES_APPLICATION.PROJECTS_SEC_RESIDENCIAL,
            ROLES_APPLICATION.PROJECTS_SEC_CI
          ]
        },
        children: [
          {
            path: `${import.meta.env.BASE_URL}interconexiones/residencial`,
            name: 'residencial',
            meta: {
              requiresAuth: true,
              requireRole: [
                ROLES_APPLICATION.PROJECTS_SEC_RESIDENCIAL,
                ROLES_APPLICATION.PROJECTS_SEC_SUPERADMIN
              ]
            },
            component: () =>
              import('@/components/pages/interconexiones/residenciales/Residenciales.vue')
          },
          {
            path: `${import.meta.env.BASE_URL}interconexiones/residencial/:id`,
            name: 'detalleResidencial',
            props: true,
            meta: {
              requiresAuth: true,
              requireRole: [
                ROLES_APPLICATION.PROJECTS_SEC_RESIDENCIAL,
                ROLES_APPLICATION.PROJECTS_SEC_SUPERADMIN
              ]
            },
            component: () =>
              import('@/components/pages/interconexiones/residenciales/ResidencialesItem.vue')
          },
          {
            path: `${import.meta.env.BASE_URL}interconexiones/ci`,
            name: 'comercialIndustrial',
            meta: {
              requiresAuth: true,
              requireRole: [
                ROLES_APPLICATION.PROJECTS_SEC_CI,
                ROLES_APPLICATION.PROJECTS_SEC_SUPERADMIN
              ]
            },
            component: () =>
              import('@/components/pages/interconexiones/comercialindustrial/ComercialIndustrial.vue')
          },
          {
            path: `${import.meta.env.BASE_URL}interconexiones/ci/:id`,
            name: 'detalleCI',
            props: true,
            meta: {
              requiresAuth: true,
              requireRole: [
                ROLES_APPLICATION.PROJECTS_SEC_CI,
                ROLES_APPLICATION.PROJECTS_SEC_SUPERADMIN
              ]
            },
            component: () =>
              import('@/components/pages/interconexiones/comercialindustrial/ComercialIndustrialItem.vue')
          }
        ]
      },
      {
        path: `${import.meta.env.BASE_URL}/`,
        redirect: `${import.meta.env.BASE_URL}dashboard`,
        component: () => import('../components/dashboard/dashboard.vue'),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: `${import.meta.env.BASE_URL}/`,
        name: 'Maindashboard',
        component: () => import('../components/dashboard/dashboard.vue'),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: `${import.meta.env.BASE_URL}dashboard`,
        name: 'Dashboard',
        component: () => import('../components/dashboard/dashboard.vue'),
        meta: {
          requiresAuth: true
        }
      },

      // APP ROUTES
      // Test ShaCdn Vue
      {
        path: `${import.meta.env.BASE_URL}test-sha-cdn`,
        component: () => import('../pages/TestShaCdn.vue'),
        meta: {
          requiresAuth: true,
          redirectIfLoggedIn: false
        }
      },
      // Projects
      {
        path: `${import.meta.env.BASE_URL}projects`,
        component: () => import('../pages/projects/ListProjects.vue'),
        meta: {
          requiresAuth: true,
          redirectIfLoggedIn: false
        }
      },
      // Projects Code Details
      {
        path: `${import.meta.env.BASE_URL}projects/:code`,
        component: () => import('../pages/projects/ShowProject.vue'),
        meta: {
          requiresAuth: true,
          redirectIfLoggedIn: false
        }
      },
      //Consumption
      {
        path: `${import.meta.env.BASE_URL}consumption/materials`,
        component: () => import('../pages/supplying/consumption_materials/index.vue'),
        meta: {
          requiresAuth: true,
          redirectIfLoggedIn: false,
          roleVerification: true
        }
      },
      // Disagreements
      {
        path: `${import.meta.env.BASE_URL}disagreements`,
        component: () => import('../pages/disagreements/index.vue'),
        meta: {
          requiresAuth: true,
          requireRole: ROLES_APPLICATION.DISAGREEMENTS,
          redirectIfLoggedIn: false
        }
      },
      //Supplying Requests Dashboard
      {
        path: `${import.meta.env.BASE_URL}supplying/requests/dashboard`,
        component: () => import('../pages/supplying/reports/index.vue'),
        meta: {
          requiresAuth: true,
          redirectIfLoggedIn: false
        }
      },

      //Supplying mobile Stock
      {
        path: `${import.meta.env.BASE_URL}supplying/mobile-warehouses/stock`,
        component: () => import('../pages/supplying/mobile-warehouses/stock/index.vue'),
        meta: {
          requiresAuth: true,
          redirectIfLoggedIn: false
        }
      },

      //Supplying Stock
      {
        path: `${import.meta.env.BASE_URL}supplying/reports/stock`,
        component: () => import('../pages/supplying/reports/stock/index.vue'),
        meta: {
          requiresAuth: true,
          redirectIfLoggedIn: false
        }
      },

      //Supplying Stock
      {
        path: `${import.meta.env.BASE_URL}supplying/reports/products`,
        component: () => import('../pages/supplying/reports/products_report/index.vue'),
        meta: {
          requiresAuth: true,
          redirectIfLoggedIn: false
        }
      },

      //Inspectors Dashboard
      {
        path: `${import.meta.env.BASE_URL}inspector/dashboard`,
        component: () => import('../pages/inspector/reports/index.vue'),
        meta: {
          requiresAuth: true,
          redirectIfLoggedIn: false
        }
      },
      // Field Reception
      {
        path: `${import.meta.env.BASE_URL}supplying/field-reception`,
        component: () => import('../pages/supplying/field_reception/ListFieldReception.vue'),
        meta: {
          requiresAuth: true,
          redirectIfLoggedIn: false
        }
      },
      {
        path: `${import.meta.env.BASE_URL}supplying/field-reception/:code`,
        component: () => import('../pages/supplying/field_reception/ShowFieldReception.vue'),
        meta: {
          requiresAuth: true,
          redirectIfLoggedIn: false
        }
      },
      // Payments SEC
      {
        path: `${import.meta.env.BASE_URL}payments-sec`,
        component: () => import('../pages/paymentsSec/index.vue'),
        meta: {
          requiresAuth: true,
          redirectIfLoggedIn: false
        }
      },
      // Requests Transfer
      {
        path: `${import.meta.env.BASE_URL}/supplying/cd/transfer-requests`,
        component: () => import('../pages/supplying/transfer_requests/ListTransferRequests.vue'),
        meta: {
          requiresAuth: true,
          redirectIfLoggedIn: false
        }
      },

      // Deliveries
      {
        path: `${import.meta.env.BASE_URL}/supplying/deliveries`,
        component: () => import('../pages/supplying/deliveries/ListDeliveries.vue'),
        meta: {
          requiresAuth: true,
          redirectIfLoggedIn: false
        }
      },
      {
        path: `${import.meta.env.BASE_URL}/supplying/deliveries/:code`,
        component: () => import('../pages/supplying/deliveries/ShowDelivery.vue'),
        meta: {
          requiresAuth: true,
          redirectIfLoggedIn: false
        }
      },

      // Profile
      {
        path: `${import.meta.env.BASE_URL}/profile`,
        component: () => import('../components/pages/profile/profile.vue'),
        meta: {
          requiresAuth: true,
          redirectIfLoggedIn: false
        }
      },
      // Supplying Mantainers
      // Virtual Stores Consumption
      {
        path: `${import.meta.env.BASE_URL}/maintainers/virtual-stores-consumption`,
        component: () =>
          import('../pages/supplying/maintainers/virtual-stores-consumption/index.vue'),
        meta: {
          requiresAuth: true,
          redirectIfLoggedIn: false
        }
      },
      {
        path: `${import.meta.env.BASE_URL}/virtual-stores-consumption/reports`,
        component: () =>
          import('../pages/supplying/maintainers/virtual-stores-consumption/reports/index.vue'),
        meta: {
          requiresAuth: true,
          redirectIfLoggedIn: false
        }
      },

      // OTIF Fill Rate
      {
        path: `${import.meta.env.BASE_URL}/supplying/otif-fill-rate`,
        component: () => import('../pages/supplying/otif-fill-rate/OtifFillRate.vue'),
        meta: {
          requiresAuth: true,
          redirectIfLoggedIn: false
        }
      },
      // Quality dashboard
      {
        path: `${import.meta.env.BASE_URL}quality/dashboard`,
        name: 'Calidad-info',
        component: () => import('@/pages/quality/info/Dashboard.vue'),
        meta: {
          requiresAuth: true,
          redirectIfLoggedIn: false
        }
      },
      // Quality Answers
      {
        path: `${import.meta.env.BASE_URL}quality/answers`,
        component: () => import('../pages/quality/answers/index.vue'),
        meta: {
          requiresAuth: true,
          redirectIfLoggedIn: false
        }
      },
      // Quality Mantainers
      // Business Units
      {
        path: `${import.meta.env.BASE_URL}quality/business-units`,
        component: () => import('../pages/quality/maintainers/business-units/index.vue'),
        meta: {
          requiresAuth: true,
          redirectIfLoggedIn: false
        }
      },
      // Mangement Areas
      {
        path: `${import.meta.env.BASE_URL}quality/mangement-areas`,
        component: () => import('../pages/quality/maintainers/mangement-areas/index.vue'),
        meta: {
          requiresAuth: true,
          redirectIfLoggedIn: false
        }
      },
      // Disciplines
      {
        path: `${import.meta.env.BASE_URL}quality/disciplines`,
        component: () => import('../pages/quality/maintainers/disciplines/index.vue'),
        meta: {
          requiresAuth: true,
          redirectIfLoggedIn: false
        }
      },
      // Document Types
      {
        path: `${import.meta.env.BASE_URL}quality/document-types`,
        component: () => import('../pages/quality/maintainers/document-types/index.vue'),
        meta: {
          requiresAuth: true,
          redirectIfLoggedIn: false
        }
      },
      // Documents
      {
        path: `${import.meta.env.BASE_URL}quality/documents`,
        component: () => import('../pages/quality/maintainers/documents/index.vue'),
        meta: {
          requiresAuth: true,
          redirectIfLoggedIn: false
        }
      },
      // Document Versions
      {
        path: `${import.meta.env.BASE_URL}quality/document-versions/:document`,
        component: () => import('../pages/quality/maintainers/document-versions/index.vue'),
        meta: {
          requiresAuth: true,
          redirectIfLoggedIn: false
        }
      },
      // Correlative Logs
      {
        path: `${import.meta.env.BASE_URL}quality/correlative-logs/:correlative`,
        component: () => import('../pages/quality/maintainers/correlative-logs/index.vue'),
        meta: {
          requiresAuth: true,
          redirectIfLoggedIn: false
        }
      },
      // Projects
      {
        path: `${import.meta.env.BASE_URL}quality/projects`,
        component: () => import('../pages/quality/projects/index.vue'),
        meta: {
          requiresAuth: true,
          redirectIfLoggedIn: false
        }
      },
      // Disciplines
      {
        path: `${import.meta.env.BASE_URL}quality/users`,
        component: () => import('../pages/quality/maintainers/users/index.vue'),
        meta: {
          requiresAuth: true,
          redirectIfLoggedIn: false
        }
      },
      // Bills
      {
        path: `${import.meta.env.BASE_URL}/bills`,
        component: () => import('../pages/bills/index.vue'),
        meta: {
          requiresAuth: true,
          redirectIfLoggedIn: false,
          requireRole: ROLES_APPLICATION.BOLETA
        }
      },
      // HumanResources
      {
        path: `${import.meta.env.BASE_URL}human-resources`,
        name: 'HumanResources',
        component: () => import('../pages/human-resources/RrHh.vue'),
        meta: {
          requiresAuth: true, //Cambiar a "false" en local
          requireRole: [ROLES_APPLICATION.MARCAJE_DE_ASISTENCIAS, ROLES_APPLICATION.ADMIN],
          redirectIfLoggedIn: false
        },
        children: [
          {
            path: 'employees', // esto genera la URL /human-resources/employees
            name: 'ListEmployees',
            component: () => import('../pages/human-resources/ListEmployees.vue'),
            meta: {
              requiresAuth: true,
              requireRole: [ROLES_APPLICATION.MARCAJE_DE_ASISTENCIAS, ROLES_APPLICATION.ADMIN],
              redirectIfLoggedIn: false
            }
          }
        ]
      },
      // Human Resources - Histórico
      {
        path: `${import.meta.env.BASE_URL}human-resources/Historico`,
        component: () => import('../pages/human-resources/Historico.vue'),
        meta: {
          requiresAuth: false,
          requireRole: [ROLES_APPLICATION.MARCAJE_DE_ASISTENCIAS, ROLES_APPLICATION.ADMIN],
          redirectIfLoggedIn: false
        }
      },

      {
        path: `${import.meta.env.BASE_URL}maintainers/roles`,
        name: 'ManagmentRoles',
        component: () => import('../pages/maintainers/managmentRoles/index.vue'),
        meta: {
          requireRole: ROLES_APPLICATION.ROLES_ADMIN
        }
      },

      {
        path: `${import.meta.env.BASE_URL}quality/maintainers/templates`,
        name: 'MaintainersTemplates',
        component: () => import('../pages/quality/maintainers/templates/index.vue'),
        meta: {
          requireRole: [ROLES_APPLICATION.ROLES_ADMIN, ROLES_APPLICATION.ADMIN]
        }
      },
      {
        path: `${import.meta.env.BASE_URL}quality/maintainers/templates/:id/responses`,
        name: 'MaintainersTemplatesResponses',
        component: () => import('../pages/quality/maintainers/templates/responses/index.vue'),
        meta: {
          requireRole: [ROLES_APPLICATION.ROLES_ADMIN, ROLES_APPLICATION.ADMIN]
        }
      },
      {
        path: `${import.meta.env.BASE_URL}quality/maintainers/templates/:id/answer`,
        name: 'MaintainersTemplatesAnswer',
        component: () => import('../pages/quality/maintainers/templates/answer/index.vue'),
        meta: {
          requireRole: [ROLES_APPLICATION.ROLES_ADMIN, ROLES_APPLICATION.ADMIN]
        }
      },
      {
        path: `${import.meta.env.BASE_URL}quality/maintainers/templates/:id`,
        name: 'MaintainersTemplatesShow',
        component: () => import('../pages/quality/maintainers/templates/show.vue'),
        meta: {
          requireRole: [ROLES_APPLICATION.ROLES_ADMIN, ROLES_APPLICATION.ADMIN]
        }
      },
      // Proforma y Facturación
      {
        path: `${import.meta.env.BASE_URL}proforma-billing`,
        redirect: `${import.meta.env.BASE_URL}proforma-billing/proforma`,
        meta: {
          requiresAuth: true,
          redirectIfLoggedIn: false,
          requireRole: [
            ROLES_APPLICATION.ADMIN,
            ROLES_APPLICATION.PROFORMA_ANALISTA_OPERACIONES,
            ROLES_APPLICATION.PROFORMA_JEFE_OPERACIONES,
            ROLES_APPLICATION.PROFORMA_ANALISTA_FINANZAS,
            ROLES_APPLICATION.PROFORMA_JEFE_FINANZAS,
            ROLES_APPLICATION.PROFORMA_EXPERIENCIA_CLIENTES
          ]
        }
      },
      {
        path: `${import.meta.env.BASE_URL}proforma-billing/proforma`,
        name: 'ProformaBillingList',
        component: () => import('../pages/proforma-facturacion/proforma.vue'),
        meta: {
          requiresAuth: true,
          redirectIfLoggedIn: false,
          requireRole: [
            ROLES_APPLICATION.ADMIN,
            ROLES_APPLICATION.PROFORMA_ANALISTA_OPERACIONES,
            ROLES_APPLICATION.PROFORMA_JEFE_OPERACIONES,
            ROLES_APPLICATION.PROFORMA_ANALISTA_FINANZAS,
            ROLES_APPLICATION.PROFORMA_JEFE_FINANZAS,
            ROLES_APPLICATION.PROFORMA_EXPERIENCIA_CLIENTES
          ]
        }
      },
      {
        path: `${import.meta.env.BASE_URL}proforma-billing/notificaciones-proforma`,
        name: 'ProformaBillingNotificacionesProforma',
        component: () => import('../pages/proforma-facturacion/notificaciones-proforma.vue'),
        meta: {
          requiresAuth: true,
          redirectIfLoggedIn: false,
          requireRole: [
            ROLES_APPLICATION.ADMIN,
            ROLES_APPLICATION.PROFORMA_ANALISTA_OPERACIONES,
            ROLES_APPLICATION.PROFORMA_JEFE_OPERACIONES,
            ROLES_APPLICATION.PROFORMA_ANALISTA_FINANZAS,
            ROLES_APPLICATION.PROFORMA_JEFE_FINANZAS,
            ROLES_APPLICATION.PROFORMA_EXPERIENCIA_CLIENTES
          ]
        }
      },
      {
        path: `${import.meta.env.BASE_URL}proforma-billing/estatus-proforma`,
        name: 'ProformaBillingEstatus',
        component: () => import('../pages/proforma-facturacion/estatus-proforma.vue'),
        meta: {
          requiresAuth: true,
          redirectIfLoggedIn: false,
          requireRole: [
            ROLES_APPLICATION.ADMIN,
            ROLES_APPLICATION.PROFORMA_ANALISTA_OPERACIONES,
            ROLES_APPLICATION.PROFORMA_JEFE_OPERACIONES,
            ROLES_APPLICATION.PROFORMA_ANALISTA_FINANZAS,
            ROLES_APPLICATION.PROFORMA_JEFE_FINANZAS,
            ROLES_APPLICATION.PROFORMA_EXPERIENCIA_CLIENTES
          ]
        }
      },
      {
        path: `${import.meta.env.BASE_URL}proforma-billing/notificaciones-facturacion`,
        name: 'ProformaBillingNotificacionesFacturacion',
        component: () => import('../pages/proforma-facturacion/notificaciones-facturacion.vue'),
        meta: {
          requiresAuth: true,
          redirectIfLoggedIn: false,
          requireRole: [
            ROLES_APPLICATION.ADMIN,
            ROLES_APPLICATION.PROFORMA_ANALISTA_OPERACIONES,
            ROLES_APPLICATION.PROFORMA_JEFE_OPERACIONES,
            ROLES_APPLICATION.PROFORMA_ANALISTA_FINANZAS,
            ROLES_APPLICATION.PROFORMA_JEFE_FINANZAS,
            ROLES_APPLICATION.PROFORMA_EXPERIENCIA_CLIENTES
          ]
        }
      },
      {
        path: `${import.meta.env.BASE_URL}proforma-billing/invoices`,
        name: 'ProformaBillingInvoices',
        component: () => import('../pages/proforma-facturacion/invoices.vue'),
        meta: {
          requiresAuth: true,
          redirectIfLoggedIn: false,
          requireRole: [
            ROLES_APPLICATION.ADMIN,
            ROLES_APPLICATION.PROFORMA_ANALISTA_OPERACIONES,
            ROLES_APPLICATION.PROFORMA_JEFE_OPERACIONES,
            ROLES_APPLICATION.PROFORMA_ANALISTA_FINANZAS,
            ROLES_APPLICATION.PROFORMA_JEFE_FINANZAS,
            ROLES_APPLICATION.PROFORMA_EXPERIENCIA_CLIENTES
          ]
        }
      },
      {
        path: `${import.meta.env.BASE_URL}proforma-billing/detail/:dia`,
        name: 'ProformaBillingDetail',
        component: () => import('../pages/proforma-facturacion/proforma-detail.vue'),
        meta: {
          requiresAuth: true,
          redirectIfLoggedIn: false,
          requireRole: [
            ROLES_APPLICATION.ADMIN,
            ROLES_APPLICATION.PROFORMA_ANALISTA_OPERACIONES,
            ROLES_APPLICATION.PROFORMA_JEFE_OPERACIONES,
            ROLES_APPLICATION.PROFORMA_ANALISTA_FINANZAS,
            ROLES_APPLICATION.PROFORMA_JEFE_FINANZAS,
            ROLES_APPLICATION.PROFORMA_EXPERIENCIA_CLIENTES
          ]
        }
      },
      {
        path: `${import.meta.env.BASE_URL}proforma-billing/distribuidoras`,
        name: 'ProformaBillingDistribuidoras',
        component: () => import('../pages/proforma-facturacion/distribuidoras.vue'),
        meta: {
          requiresAuth: true,
          redirectIfLoggedIn: false,
          requireRole: [
            ROLES_APPLICATION.ADMIN,
            ROLES_APPLICATION.PROFORMA_ANALISTA_OPERACIONES,
            ROLES_APPLICATION.PROFORMA_JEFE_OPERACIONES,
            ROLES_APPLICATION.PROFORMA_ANALISTA_FINANZAS,
            ROLES_APPLICATION.PROFORMA_JEFE_FINANZAS,
            ROLES_APPLICATION.PROFORMA_EXPERIENCIA_CLIENTES
          ]
        }
      },
      {
        path: `${import.meta.env.BASE_URL}proforma-billing/resumen-esco`,
        name: 'ProformaBillingResumenEsco',
        component: () => import('../pages/proforma-facturacion/resumen-esco.vue'),
        meta: {
          requiresAuth: true,
          redirectIfLoggedIn: false,
          requireRole: [
            ROLES_APPLICATION.ADMIN,
            ROLES_APPLICATION.PROFORMA_ANALISTA_OPERACIONES,
            ROLES_APPLICATION.PROFORMA_JEFE_OPERACIONES,
            ROLES_APPLICATION.PROFORMA_ANALISTA_FINANZAS,
            ROLES_APPLICATION.PROFORMA_JEFE_FINANZAS,
            ROLES_APPLICATION.PROFORMA_EXPERIENCIA_CLIENTES
          ]
        }
      },
      {
        path: `${import.meta.env.BASE_URL}proforma-billing/monitoring`,
        name: 'ProformaBillingMonitoring',
        component: () => import('../pages/proforma-facturacion/monitoring.vue'),
        meta: {
          requiresAuth: true,
          redirectIfLoggedIn: false,
          requireRole: [
            ROLES_APPLICATION.ADMIN,
            ROLES_APPLICATION.PROFORMA_ANALISTA_OPERACIONES,
            ROLES_APPLICATION.PROFORMA_JEFE_OPERACIONES,
            ROLES_APPLICATION.PROFORMA_ANALISTA_FINANZAS,
            ROLES_APPLICATION.PROFORMA_JEFE_FINANZAS,
            ROLES_APPLICATION.PROFORMA_EXPERIENCIA_CLIENTES
          ]
        }
      },
      {
        path: `${import.meta.env.BASE_URL}proforma-billing/informes-clientes`,
        name: 'ProformaBillingInformesClientes',
        component: () => import('../pages/proforma-facturacion/informes-clientes.vue'),
        meta: {
          requiresAuth: true,
          redirectIfLoggedIn: false,
          requireRole: [
            ROLES_APPLICATION.ADMIN,
            ROLES_APPLICATION.PROFORMA_ANALISTA_OPERACIONES,
            ROLES_APPLICATION.PROFORMA_JEFE_OPERACIONES,
            ROLES_APPLICATION.PROFORMA_ANALISTA_FINANZAS,
            ROLES_APPLICATION.PROFORMA_JEFE_FINANZAS,
            ROLES_APPLICATION.PROFORMA_EXPERIENCIA_CLIENTES
          ]
        }
      },
      {
        path: `${import.meta.env.BASE_URL}proforma-billing/facturacion`,
        name: 'ProformaBillingFacturacion',
        component: () => import('../pages/proforma-facturacion/facturacion.vue'),
        meta: {
          requiresAuth: true,
          redirectIfLoggedIn: false,
          requireRole: [
            ROLES_APPLICATION.ADMIN,
            ROLES_APPLICATION.PROFORMA_ANALISTA_FINANZAS,
            ROLES_APPLICATION.PROFORMA_JEFE_FINANZAS
          ]
        }
      },
      {
        path: `${import.meta.env.BASE_URL}proforma-billing/facturacion-masiva`,
        name: 'ProformaBillingFacturacionMasiva',
        component: () => import('../pages/proforma-facturacion/facturacion-masiva.vue'),
        meta: {
          requiresAuth: true,
          redirectIfLoggedIn: false,
          requireRole: [
            ROLES_APPLICATION.ADMIN,
            ROLES_APPLICATION.PROFORMA_ANALISTA_FINANZAS,
            ROLES_APPLICATION.PROFORMA_JEFE_FINANZAS
          ]
        }
      },
      {
        path: `${import.meta.env.BASE_URL}/maintainers/roles`,
        name: 'ManagmentRoles',
        component: () => import('../pages/maintainers/managmentRoles/index.vue'),
        meta: {
          requiresAuth: true,
          redirectIfLoggedIn: false,
          requireRole: [
            ROLES_APPLICATION.ADMIN,
            ROLES_APPLICATION.PROFORMA_ANALISTA_OPERACIONES,
            ROLES_APPLICATION.PROFORMA_JEFE_OPERACIONES,
            ROLES_APPLICATION.PROFORMA_ANALISTA_FINANZAS,
            ROLES_APPLICATION.PROFORMA_JEFE_FINANZAS,
            ROLES_APPLICATION.PROFORMA_EXPERIENCIA_CLIENTES
          ]
        }
      },
      {
        path: `${import.meta.env.BASE_URL}proforma-billing/facturacion`,
        name: 'ProformaBillingFacturacion',
        component: () => import('../pages/proforma-facturacion/facturacion.vue'),
        meta: {
          requiresAuth: true,
          redirectIfLoggedIn: false,
          requireRole: [
            ROLES_APPLICATION.ADMIN,
            ROLES_APPLICATION.PROFORMA_ANALISTA_FINANZAS,
            ROLES_APPLICATION.PROFORMA_JEFE_FINANZAS
          ]
        }
      },
      {
        path: `${import.meta.env.BASE_URL}proforma-billing/facturacion-masiva`,
        name: 'ProformaBillingFacturacionMasiva',
        component: () => import('../pages/proforma-facturacion/facturacion-masiva.vue'),
        meta: {
          requiresAuth: true,
          redirectIfLoggedIn: false,
          requireRole: [
            ROLES_APPLICATION.ADMIN,
            ROLES_APPLICATION.PROFORMA_ANALISTA_FINANZAS,
            ROLES_APPLICATION.PROFORMA_JEFE_FINANZAS
          ]
        }
      },
      {
        path: `${import.meta.env.BASE_URL}sipe/kpi-ejecucion`,
        name: 'kpi-ejecucion',
        component: () => import('../pages/sipe/kpi_ejecucion.vue'),
        meta: {
          requiresAuth: true,
          redirectIfLoggedIn: false,
          requireRole: [
            ROLES_APPLICATION.ADMIN,
            ROLES_APPLICATION.SIPE_PM_EJECUCION,
            ROLES_APPLICATION.SIPE_LIDER_EJECUCION
          ]
        }
      },
      {
        path: `${import.meta.env.BASE_URL}sipe/gestion-kpi`,
        name: 'gestion-kpi',
        component: () => import('../pages/sipe/gestion_kpi.vue'),
        meta: {
          requiresAuth: true,
          redirectIfLoggedIn: false,
          requireRole: [
            ROLES_APPLICATION.ADMIN,
            ROLES_APPLICATION.SIPE_PM_EJECUCION,
            ROLES_APPLICATION.SIPE_LIDER_EJECUCION
          ]
        }
      },
      {
        path: `${import.meta.env.BASE_URL}sipe/gestion-kpi/kpi-subsanacion`,
        name: 'kpi-subsanacion',
        component: () => import('../pages/sipe/kpi_subsanacion.vue'),
        meta: {
          requiresAuth: true,
          redirectIfLoggedIn: false,
          requireRole: [
            ROLES_APPLICATION.ADMIN,
            ROLES_APPLICATION.SIPE_PM_EJECUCION,
            ROLES_APPLICATION.SIPE_LIDER_EJECUCION
          ]
        }
      },
      {
        path: `${import.meta.env.BASE_URL}sipe/gestion-kpi/kpi-csat`,
        name: 'kpi-csat',
        component: () => import('../pages/sipe/kpi_csat.vue'),
        meta: {
          requiresAuth: true,
          redirectIfLoggedIn: false,
          requireRole: [
            ROLES_APPLICATION.ADMIN,
            ROLES_APPLICATION.SIPE_PM_EJECUCION,
            ROLES_APPLICATION.SIPE_LIDER_EJECUCION
          ]
        }
      },
      {
        path: `${import.meta.env.BASE_URL}sipe/gestion-kpi/kpi-bono-total`,
        name: 'kpi-bono-total',
        component: () => import('../pages/sipe/kpi_bono_total.vue'),
        meta: {
          requiresAuth: true,
          redirectIfLoggedIn: false,
          requireRole: [
            ROLES_APPLICATION.ADMIN,
            ROLES_APPLICATION.SIPE_PM_EJECUCION,
            ROLES_APPLICATION.SIPE_LIDER_EJECUCION
          ]
        }
      },
      {
        path: `${import.meta.env.BASE_URL}budge/create`,
        component: () => import('../pages/budge/create.vue'),
        meta: {
          requiresAuth: true,
          redirectIfLoggedIn: false,
          requireRole: [ROLES_APPLICATION.BUDGET]
        }
      },
      {
        path: `${import.meta.env.BASE_URL}budge/compare`,
        component: () => import('../pages/budge/compare.vue'),
        meta: {
          requiresAuth: true,
          redirectIfLoggedIn: false,
          requireRole: [ROLES_APPLICATION.BUDGET]
        }
      }
      // {
      //   path: `${import.meta.env.BASE_URL}gestion-cdv`,
      //   name: 'gestion-cdv',
      //   component: () => import('@/components/pages/cdv/gestion_cdv.vue'),
      //   meta: {
      //     requiresAuth: true,
      //     redirectIfLoggedIn: false
      //     // @todo: requireRole: []
      //     // requireRole: []
      //   }
      // }
    ]
  },

  // Errrorpage
  {
    path: `${import.meta.env.BASE_URL}custompages`,
    component: Errorpagesinfo,
    children: [
      {
        path: 'signin',
        component: () => import('../components/custompages/signin/signin.vue'),
        meta: {
          requiresAuth: false,
          redirectIfLoggedIn: true
        }
      },
      {
        path: 'signup',
        component: () => import('../components/custompages/signup/signup.vue'),
        meta: {
          requiresAuth: false,
          redirectIfLoggedIn: true
        }
      },
      {
        path: 'forgotpassword',
        component: () => import('../components/custompages/forgotpassword/forgotpassword.vue'),
        meta: {
          requiresAuth: false,
          redirectIfLoggedIn: true
        }
      },
      {
        path: 'resetpassword',
        component: () => import('../components/custompages/resetpassword/restpassword.vue')
      },
      {
        path: 'lockscreen',
        component: () => import('../components/custompages/lockscreen/lockscreen.vue')
      },
      {
        path: 'underconstruction',
        component: () => import('../components/custompages/underconstruction/underconstruction.vue')
      },

      {
        path: 'error404/',
        component: () => import('../components/custompages/error404/error404.vue')
      },
      {
        path: 'error500',
        component: () => import('../components/custompages/error500/error500.vue')
      }
    ]
  },

  // Messageinformations
  {
    path: `${import.meta.env.BASE_URL}/pages`,
    component: Messagesinformation,
    children: [
      {
        path: 'successmessage',
        component: () => import('../components/pages/successsmessage/successmessage.vue')
      },
      {
        path: 'dangermessage',
        component: () => import('../components/pages/dangermessage/dangermessage.vue')
      },
      {
        path: 'warningmessage',
        component: () => import('../components/pages/warningmessage/warningmessage.vue')
      }
    ]
  },

  // LoginPage
  {
    path: `${import.meta.env.BASE_URL}healthcheck`,
    name: 'healthcheck',
    component: () => import('../pages/healthcheck/index.vue'),
    meta: {
      requiresAuth: false,
      redirectIfLoggedIn: false
    }
  },
  // LoginPage
  {
    path: `${import.meta.env.BASE_URL}login`,
    name: 'login',
    component: () => import('../pages/auth/login/Login.vue'),
    meta: {
      requiresAuth: false,
      redirectIfLoggedIn: true
    }
  },
  {
    path: `${import.meta.env.BASE_URL}auth/login/google`,
    redirect: `${import.meta.env.BASE_URL}login`
  },

  // Forgot password
  {
    path: `${import.meta.env.BASE_URL}forgotpassword`,
    name: 'forgot-password',
    component: () => import('../components/custompages/forgotpassword/forgotpassword.vue'),
    meta: {
      requiresAuth: false,
      redirectIfLoggedIn: true
    }
  },

  // // Reset password
  {
    path: `${import.meta.env.BASE_URL}resetpassword`,
    name: 'reset-password',
    component: () => import('../components/custompages/resetpassword/restpassword.vue'),
    meta: {
      requiresAuth: false,
      redirectIfLoggedIn: true
    }
  },

  // // Portal EPP
  {
    path: `${import.meta.env.BASE_URL}epp`,
    name: 'EPP',
    component: () => import('../pages/epp/dashboardEpp.vue'),
    meta: {
      requiresAuth: true,
      redirectIfLoggedIn: false,
      requireRole: [
        ROLES_APPLICATION.EPP_SOLICITANTE,
        ROLES_APPLICATION.EPP_PREVENCIONISTA,
        ROLES_APPLICATION.EPP_ASESOR_PREVENCIONISTA,
        ROLES_APPLICATION.EPP_MESA_AYUDA,
        ROLES_APPLICATION.ADMIN
      ]
    }
  },

  // // Nueva solicitud EPP
  {
    path: `${import.meta.env.BASE_URL}epp/solicitud`,
    name: 'EPP_solicitud',
    component: () => import('../pages/epp/nuevaSolicitudEpp.vue'),
    meta: {
      requiresAuth: true,
      redirectIfLoggedIn: false
    }
  },

  // // Dashboard Prevencionistas EPP
  {
    path: `${import.meta.env.BASE_URL}epp/prevencionistas`,
    name: 'EPP_prevencionistas',
    component: () => import('../pages/epp/prevencionistas/dashboardPrevencionistas.vue'),
    meta: {
      requiresAuth: true,
      redirectIfLoggedIn: false,
      requireRole: [
        ROLES_APPLICATION.EPP_PREVENCIONISTA,
        ROLES_APPLICATION.EPP_ASESOR_PREVENCIONISTA,
        ROLES_APPLICATION.ADMIN
      ]
    }
  },

  // // Configurar Prevencionistas EPP
  {
    path: `${import.meta.env.BASE_URL}epp/configurar-prevencionistas`,
    name: 'EPP_configurar_prevencionistas',
    component: () => import('../pages/epp/configPrevencionistas/configurarPrevencionistas.vue'),
    meta: {
      requiresAuth: true,
      redirectIfLoggedIn: false,
      requireRole: [ROLES_APPLICATION.EPP_MESA_AYUDA, ROLES_APPLICATION.ADMIN]
    }
  },

  //.....Errorpage.....
  {
    path: '/:pathMatch(.*)*',
    name: '404page',
    component: () => import('../components/custompages/error404/error404.vue')
  }

  //Dinamic fotovoltaicos
  // {
  //   path: '/fotovoltaicos',
  //   name: 'fotovoltaicosDashboard',
  //   component: fotovoltaicosDashboard
  // },
  // {
  //   path: '/fotovoltaicos/:id',
  //   name: 'fotovoltaicosDetails',
  //   component: fotovoltaicosDetails,
  //   props: true // ←  Parámetro dinámico :id
  // },
  // {
  //   path: '/',
  //   redirect: '/fotovoltaicos'
  // }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

const canNavigate = (to) => to.matched.some((record) => record.meta.requiresAuth)

// Usa la MISMA clave que en el componente
const STORAGE_KEY = 'stepsData_v2'

// Guard #1: RESET por URL (?reset=1)
router.beforeEach((to, from, next) => {
  const raw = to.query?.reset
  const resetParam = Array.isArray(raw) ? raw[0] : raw

  if (resetParam === '1') {
    // 1) borrar el estado persistido
    try {
      window.localStorage.removeItem(STORAGE_KEY)
    } catch (e) {
      // Ignore storage errors
    }

    // 2) quitar el query param sin recargar y sin loop
    const rest = { ...to.query }
    delete rest.reset
    return next({
      path: to.path,
      params: to.params,
      query: rest,
      replace: true // evita historial y bucles
    })
  }

  // si no hay reset, seguir con el siguiente guard
  return next()
})

// DEV BYPASS
// router.beforeEach((to, _, next) => {
//   const storeAuth = authStore()
//   localStorage.setItem('accessToken', 'dev-token')
//   localStorage.setItem('refreshToken', 'dev-refresh')
//   storeAuth.roles = [ROLES_APPLICATION.ADMIN]
//   storeAuth.fullRoles = { roles: [ROLES_APPLICATION.ADMIN], extras: [] }
//   storeAuth.logged = true
//   return next()
// })

router.beforeEach((to, _, next) => {
  const isLoggedIn = !!localStorage.getItem('accessToken')
  const storeAuth = authStore()

  if (canNavigate(to)) {
    // Redict to profile if new user no have roles
    if (!checkIsNotMyProfileRole(storeAuth.fullRoles) && to.fullPath !== '/profile') {
      return next('/profile')
    }
    if (to.meta.roleVerification) {
      if (
        !storeAuth.roles.length ||
        !checkUserHaveRoles(
          [ROLES_APPLICATION.ADMIN, ROLES_APPLICATION.ACCOUNTING_SOURCING],
          storeAuth.roles
        )
      ) {
        return next('/')
      }
    }
    if (to.meta.requireRole) {
      const rolesToVerify = Array.isArray(to.meta.requireRole)
        ? to.meta.requireRole
        : [to.meta.requireRole]
      if (!storeAuth.roles.length || !checkUserHaveRoles(rolesToVerify, storeAuth.roles)) {
        return next('/')
      }
    }
    if (!isLoggedIn) {
      if (!to.fullPath.includes('login') && to.redirectedFrom?.fullPath !== '/') {
        return next(
          decodeURIComponent(`${import.meta.env.BASE_URL}login?redirect_url=${to.fullPath}`)
        )
      }
      return next({ path: `${import.meta.env.BASE_URL}login` })
    }
  }
  if (to.meta.redirectIfLoggedIn && isLoggedIn) return next('/')
  return next()
})

const checkIsNotMyProfileRole = (roles = []) => {
  if (
    roles.extras &&
    roles.extras.length > 0 &&
    roles.extras.some((extra) => extra.name === 'my-profile') &&
    roles.roles.length == 0
  ) {
    return false
  } else {
    return true
  }
}

export default router
